import { useEffect, useState } from "react";
import Chatbot, { createChatBotMessage } from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";

const CHAT_STORAGE_KEY = "ali_portfolio_chat_history";
const CHAT_OPEN_KEY = "ali_portfolio_chat_open";

const config = {
  initialMessages: [
    createChatBotMessage(
      "Hi! Ask me anything about Muhammad Ali or this portfolio.",
      {
        delay: 0,
      }
    ),
  ],
  botName: "AliBot",
  customComponents: {},
};

class ActionProvider {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createChatBotMessage: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setState: any;

  // react-chatbot-kit calls this with (createChatBotMessage, setStateFunc, createClientMessage)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(createChatBotMessage: any, setStateFunc: any) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private addMessageToState(message: any) {
    this.setState((prev: any) => ({
      ...prev,
      messages: [...prev.messages, message],
    }));
  }

  async handleUserMessage(message: string) {
    try {
      const res = await fetch(
        "https://cmiec0w0two35v4jo9p8r0c5y.agent.a.smyth.ai/api/aboutme",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            question: message,
          }),
        }
      );

      if (!res.ok) {
        const errorMessage = this.createChatBotMessage(
          "Sorry, I had trouble reaching the backend. Please try again."
        );
        this.addMessageToState(errorMessage);
        return;
      }

      const data = await res.json();
      const answer =
        typeof data === "string"
          ? data
          : data?.result?.Output?.output || JSON.stringify(data);
      console.log(answer);
      const botMessage = this.createChatBotMessage(answer);
      this.addMessageToState(botMessage);
    } catch (e) {
      const errorMessage = this.createChatBotMessage(
        "Something went wrong while fetching the answer."
      );
      this.addMessageToState(errorMessage);
    }
  }
}

class MessageParser {
  actionProvider: ActionProvider;

  constructor(actionProvider: ActionProvider) {
    this.actionProvider = actionProvider;
  }

  parse(message: string) {
    const trimmed = message.trim();
    if (!trimmed) return;
    this.actionProvider.handleUserMessage(trimmed);
  }
}

function ChatBotWidget() {
  const [isOpen, setIsOpen] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    try {
      return window.localStorage.getItem(CHAT_OPEN_KEY) === "1";
    } catch {
      return false;
    }
  });

  const [messageHistory, setMessageHistory] = useState<any[] | null>(() => {
    if (typeof window === "undefined") return null;
    try {
      const raw = window.localStorage.getItem(CHAT_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(CHAT_OPEN_KEY, isOpen ? "1" : "0");
    } catch {
      // ignore
    }
  }, [isOpen]);

  const toggleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="chatbot-widget">
      <button type="button" className="chatbot-launcher" onClick={toggleOpen}>
        <span className="chatbot-launcher-orbit" />
        <img src="./assets/profile.jpg" alt="Chat with AliBot" />
      </button>

      {isOpen && (
        <div className="chatbot-panel">
          <Chatbot
            config={config}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            messageParser={MessageParser as unknown as any}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            actionProvider={ActionProvider as unknown as any}
            messageHistory={messageHistory || undefined}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            saveMessages={(messages: any) => {
              try {
                window.localStorage.setItem(
                  CHAT_STORAGE_KEY,
                  JSON.stringify(messages)
                );
                setMessageHistory(messages);
              } catch {
                // ignore
              }
            }}
            runInitialMessagesWithHistory={false}
          />
        </div>
      )}
    </div>
  );
}

export default ChatBotWidget;
